import '.a{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.n{align-items:center;}.ssr-plugin'
import '.g{gap:2rem;}.ssr-plugin'
import '.o{text-align:center;}.ssr-plugin'
import '.p{gap:1.5rem;}.ssr-plugin'
import { styled } from 'inlines'
import { PageLayout } from '../layout/PageLayout'
import { Title } from '../../components/core/typography/Title'
import { Text } from '../../components/core/typography/Text'
import { useState, useEffect } from 'react'
import { useTranslations } from '@i18n/useLanguage'
import { DiscoverSection } from './sections/Discover'
import Column from '@app/components/layout/Column'
import { HousingFormsSection } from './sections/HousingForms'
import { AboutSection } from './sections/About'
import { StatsAndCtaSection } from './sections/StatsAndCta'
import { Tabs } from '@app/components/core/tabs/Tabs'
import { pages } from '@app/util/links'
import { useParamSearch } from '@app/util/hooks/useParamState'
import { SearchBar } from '@app/components/blocks/searchBar/SearchBar'
import { navigate } from 'wouter/use-browser-location'
import useMediaQuery from '@app/util/useMediaQuery'
import { StoriesSection } from './sections/Stories'
import { useQuery } from '@based/sdk/react'
import { MaintenancePage } from './MaintenancePage'
import InitiativeDefIcon from '@app/assets/discovery/initiativen-default.svg'
import LocationDefIcon from '@app/assets/discovery/location-default.svg'
import RegionDefIcon from '@app/assets/discovery/regio-default.svg'
import HousingFormDefIcon from '@app/assets/discovery/woonvorm-default.svg'
import InitiativeActiveIcon from '@app/assets/discovery/initiativen-active-hover.svg'
import LocationActiveIcon from '@app/assets/discovery/location-active-hover.svg'
import RegionActiveIcon from '@app/assets/discovery/regio-active-hover.svg'
import HousingFormActiveIcon from '@app/assets/discovery/woonvorm-active-hover.svg'


const tabs = {
  initiatives: 'initiatives',
  locations: 'locations',
  regions: 'regions',
  housingForms: 'housingForms',
} as const
type Tabs = keyof typeof tabs

export const Landing = () => {
  const isMobile = useMediaQuery()
  const translations = useTranslations().app
  const { data: maintenance } = useQuery('maintenance-status')

  const [searchTerm, setSearchTerm] = useParamSearch()
  const [searchBarInput, setSearchBarInput] = useState('')

  useEffect(() => {
    if (searchTerm.trim() !== '') {
      const searchParam = encodeURIComponent(searchTerm)
      navigate(`${pages.initiatives}?search=${searchParam}`)
    }
  }, [searchTerm, setSearchTerm])

  if (maintenance?.enabled) {
    return <MaintenancePage message={maintenance.message} />
  }

  const placeholder = isMobile
    ? translations.discoveryPage.searchPlaceholder.mobile
    : translations.discoveryPage.searchPlaceholder.initiatives

  return (
    <PageLayout gap={isMobile ? '1rem' : '3rem'}>
      {/* Hero Section */}
      <div className="a m n g"
        style={{
          padding: isMobile ? '1rem' : '4rem 2rem',}}
      >
        <div className="o a m p"
        >
          <Title.H1>{translations.landingPage.title}</Title.H1>
          <Text.Large>{translations.landingPage.description}</Text.Large>
        </div>
        <Column
          alignItems="center"
          gap="2.5rem"
          style={{ alignSelf: 'center' }}
        >
          <Tabs.Group
            selectedTab={tabs.initiatives}
            style={{ gap: isMobile ? '1rem' : '2.5rem' }}
          >
            <Tabs.HeaderTab
              icon={InitiativeDefIcon}
              activeIcon={InitiativeActiveIcon}
              label={translations.discoveryPage.initiatives}
              tabKey={tabs.initiatives}
              href={pages.initiatives}
              onSelectTab={() => navigate(pages.initiatives)}
            />
            <Tabs.HeaderTab
              icon={LocationDefIcon}
              activeIcon={LocationActiveIcon}
              label={translations.discoveryPage.plots}
              tabKey={tabs.locations}
              href={pages.plots}
              onSelectTab={() => navigate(pages.plots)}
            />
            <Tabs.HeaderTab
              icon={RegionDefIcon}
              activeIcon={RegionActiveIcon}
              label={translations.discoveryPage.regions}
              tabKey={tabs.regions}
              href={pages.regions}
              onSelectTab={() => navigate(pages.regions)}
            />
            <Tabs.HeaderTab
              icon={HousingFormDefIcon}
              activeIcon={HousingFormActiveIcon}
              label={translations.discoveryPage.housingForms}
              tabKey={tabs.housingForms}
              href={pages.housingForms}
              onSelectTab={() => navigate(pages.housingForms)}
            />
          </Tabs.Group>
          <SearchBar
            placeholder={placeholder}
            searchTerm={''}
            setSearchTerm={setSearchTerm}
            searchBarInput={searchBarInput}
            setSearchBarInput={setSearchBarInput}
            currentView={'grid'}
            onSwitchView={() => navigate(pages.initiatives + '?view=map')}
            onFiltersOpen={() => navigate(pages.initiatives)}
          />
        </Column>
      </div>
      <Column alignItems="stretch" gap={isMobile ? '3rem' : '6.25rem'}>
        <DiscoverSection />
        <HousingFormsSection />
        <AboutSection />
        <StoriesSection />
        <StatsAndCtaSection />
        {/* <NewsletterSection />
        <styled.div style={{ height: '6.25rem' }} /> */}
      </Column>
    </PageLayout>
  )
}
